import React from "react";
import {IProps as IScreenProps, Screen} from '~common/screen';
import { Styled } from './styled'
import { StyledScreen } from '~common/screen'
import Form from '~/components/form'

interface IProps {
  screenProps?: IScreenProps
}

const QuestionsScreen: React.FC<IProps> = (props) => {
  return (
    <Screen
      title={<span>Остались <StyledScreen.GreenText>вопросы?</StyledScreen.GreenText></span>}
      bottomLine={true}
      {...props.screenProps}
    >
      <Styled.SubTitle>Оставьте свой номер и мы свяжемся с Вами.</Styled.SubTitle>
      <Form
        text='Хочу консультацию'
        isRedirect={false}
        pageName='Главная'
      />
    </Screen>
  )
}

export { QuestionsScreen }